module.exports = __webpack_public_path__ + "media/images/boat-ac80b8336d846073ca3ead7f9205e390.png";